import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { SETTINGS } from "@/constants/testIds";

export function SmtpSettings({ settings, smtp, setSmtp, onSave }) {
  return (
    <Card className="p-6 border-slate-200 shadow-sm">
      <h3 className="text-base font-semibold text-slate-900 mb-4">Servidor SMTP</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">Host</Label>
          <Input value={smtp.host} onChange={(e) => setSmtp({ ...smtp, host: e.target.value })}
            placeholder="smtp.office365.com" className="focus-visible:ring-orange-500" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">Puerto</Label>
          <Input type="number" value={smtp.port}
            onChange={(e) => setSmtp({ ...smtp, port: parseInt(e.target.value || "587", 10) })}
            className="focus-visible:ring-orange-500" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">Usuario</Label>
          <Input value={smtp.user} onChange={(e) => setSmtp({ ...smtp, user: e.target.value })}
            className="focus-visible:ring-orange-500" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">
            Contraseña {settings?.smtp?.password_set && (
              <span className="text-slate-400 normal-case font-normal ml-1">(dejar en blanco)</span>
            )}
          </Label>
          <Input type="password" value={smtp.password}
            onChange={(e) => setSmtp({ ...smtp, password: e.target.value })}
            className="focus-visible:ring-orange-500" />
        </div>
        <div className="space-y-1.5 md:col-span-2">
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">
            Correo remitente
          </Label>
          <Input value={smtp.from_address}
            onChange={(e) => setSmtp({ ...smtp, from_address: e.target.value })}
            placeholder="firmas@hospital.example.com"
            className="focus-visible:ring-orange-500" />
        </div>
        <div className="flex items-center gap-2 md:col-span-2">
          <Switch checked={smtp.use_tls}
            onCheckedChange={(v) => setSmtp({ ...smtp, use_tls: v })} />
          <Label className="text-sm text-slate-700">Usar TLS/STARTTLS</Label>
        </div>
      </div>
      <div className="mt-6 flex justify-end">
        <Button onClick={onSave} className="bg-orange-600 hover:bg-orange-700 text-white"
          data-testid={SETTINGS.saveSmtpBtn}>
          Guardar SMTP
        </Button>
      </div>
    </Card>
  );
}
